import Location from 'react-app-location';

export const RoleInfoLocation = new Location('/personal-data/role-info');
